export default class alphabeticValidator {
    constructor() {
    }

    validate(value, country) {
        switch(country) {
            case 'gr':
            case 'jp':
            case 'hk':
            case 'my':
            case 'in':
            case 'il':
                // not-numeric
                return !!(value.match(/^([^0-9]+)$/));

            default:
                // alphabetic (extended)
                return !!(value.match(/^[a-zA-Z\xC0-\xD6\xD8-\xF6\xF8-\xFF\u0100-\u017E\u01CD-\u01FF-'\s]+$/));
        }
    }
}
